import React, { PureComponent, createContext } from 'react';
import PropTypes from 'prop-types';
import bowser from 'bowser';

const { Provider, Consumer } = createContext();

export default class BowserProvider extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    userAgent: PropTypes.string,
  };

  render() {
    const { userAgent } = this.props;

    return (
      // eslint-disable-next-line no-underscore-dangle
      <Provider value={userAgent ? bowser._detect(userAgent) : bowser}>
        {this.props.children}
      </Provider>
    );
  }
}

export { Consumer };
